import { useEffect, useState } from 'react';

const initVeeroPdMeasuringTool = ({ setPdToolInitialized, setAppError }) => {
	try {
		const loading = typeof window !== 'undefined' && !window?.EyeSize?.launch;

		if (!loading) {
			setAppError(false);
			setPdToolInitialized(true);
		}
	} catch (error) {
		console.error('[Veero SDK] Unable to init', error);
		setAppError(true);
	}
};

const useLoadVeero = ({ setAppError, pdScriptLoaded }) => {
	const [pdToolInitialized, setPdToolInitialized] = useState(false);

	useEffect(() => {
		if (pdScriptLoaded) {
			initVeeroPdMeasuringTool({ setPdToolInitialized, setAppError });
		}
	}, [pdScriptLoaded]);

	return pdToolInitialized;
};

export { useLoadVeero };
